<template>
    <div>
        <widget-dialog :bus="bus"
                       @cancel="dialogCancelled"
                       @submit="dialogSubmitted"/>
        <div class="wrapper">
            <div class="widgets">
                <ul class="widgets__list">
                    <p class="widgets__list--empty"
                       v-show="widgets.length === 0">
                        <span v-show="!lessDetails">
                            Zawsze w szczegółach wyświetla się zdjęcie i opis. Wykorzystaj widgety, by dodać więcej informacji.<br>
                        </span>
                        Wybierz widget z listy po prawej stronie.
                    </p>
                    <li class="widget"
                        v-for="widget, i in widgets"
                        :class="{'widget--error': errors[i] && Object.keys(errors[i]).length > 0}"
                        @click="editWidget(widget, errors[i])">
                        <div class="buttons">
                            <el-button @click.stop="changeOrder(widgets, i, 1)"
                                       v-if="i !== widgets.length - 1"
                                       size="small"
                                       title="Przesuń w dół">
                                <i class="fa fa-arrow-down"></i>
                            </el-button>
                            <el-button @click.stop="changeOrder(widgets, i, -1)"
                                       :style="{opacity: i !== 0 ? 1 : 0}"
                                       size="small"
                                       title="Przesuń do góry">
                                <i class="fa fa-arrow-up"></i>
                            </el-button>
                            <el-button @click.stop="removeWidget(widget, i)"
                                       type="danger"
                                       size="small">
                                <i class="fa fa-remove"></i>
                            </el-button>
                        </div>
                        <strong>{{ widget.name_pl || 'Widget bez nazwy' }}</strong><br>
                        <small>{{ getLabel(widget.resourcetype) }}</small>
                    </li>
                </ul>
            </div>
            <div class="types">
                <ul class="types__list">
                    <li class="type"
                        v-for="type, key in $store.state.idBasedWidgetTypes"
                        @click="addWidget(type)">
                        <i class="fa fa-plus-circle"></i>
                        {{ type.label }}
                        <div>
                            <img class="widget__icon"
                                 @error="iconLoadError(type.resourcetype)"
                                 :src="`/static/widgets/icons/${type.resourcetype}.png`" alt="">
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import WidgetDialog from '@/components/widgets/WidgetDialog'
    import {Widget} from "@/api";
    import Vue from 'vue'

    export default {
        props: ["widgets", "errors", "lessDetails"],
        data () {
            return {
                bus: new Vue(),
                selectedWidget: {}
            }
        },
        beforeMount () {
            this.fetchData()
        },
        components: {
            WidgetDialog
        },
        methods: {
            fetchData () {
                this.$store.dispatch('fetchAvailableWidgets')
                this.$store.dispatch('fetchWidgetTypes')
            },
            editWidget (widget, errors) {
                this.bus.$emit('openWidgetDialog', widget, errors)
            },
            addWidget (type) {
                this.widgets.push({
                    'resourcetype': type.resourcetype
                })
            },
            getLabel (resourcetype) {
                const widget = this.$store.state.widgetTypes[resourcetype]
                const label = widget && widget.label
                return label || resourcetype
            },
            dialogCancelled () {
                // cancel
            },
            dialogSubmitted (oldForm, newForm) {
                const index = this.widgets.indexOf(newForm)
                if (index > -1) {
                    this.$set(this.widgets, index, oldForm)
                }
                this.$forceUpdate()
            },
            iconLoadError (error) {
                console.log('Nie znaleziono ikony dla widgetu ', error)
            },
            removeWidget (widget, i) {
                this.removeItemFromFormset(this.widgets, widget)
                this.removeItemFromFormset(this.errors, this.errors[i])
            }
        }
    }
</script>
<style lang="scss" scoped>
    .wrapper {
        display: flex;
        justify-content: space-between;
    }

    .widgets {
        width: 72%;
        &__list {
            padding: 0;
            list-style-type: none;
            &--empty {
                font-size: 13px;
            }
        }
    }

    .widget {
        width: 100%;
        padding: 15px 180px 15px 10px;
        border-top: 1px solid #f3f3f3;
        border-bottom: 1px solid #f3f3f3;
        cursor: pointer;
        position: relative;
        &:hover {
            background: #f3f3f3;
        }
        &--error {
            border-left: 3px solid red;
            color: red;
        }
        &__icon {
            max-width: 100%;
            max-height: 43px;
            display: inline-block;
            text-align: right;
        }
    }

    .types {
        background: #f8f8f8;
        width: 28%;
        padding: 0 20px;
        &__list {
            padding: 0;
            list-style-type: none;
            text-align: right;
        }
    }

    .type {
        cursor: pointer;
        padding: 6px 10px;
        border-bottom: 1px solid #e2e2e2;
        transition: all .5s;
        & i {
            float: left;
            margin-top: 5px;
        }
        &:hover {
            background: #e2e2e2;
        }
    }

    .buttons {
        position: absolute;
        top: 20px;
        right: 20px;
    }
</style>


// WEBPACK FOOTER //
// WidgetsInput.vue?4992c80a